import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

import * as _ from 'underscore';
import {PortalServiceUpdater} from '../../form/model/portal.service.updater';
import {HttpParams} from '@angular/common/http';

@Injectable()
export class VnaCampaignService implements PortalServiceUpdater{

    constructor(private api: ApiService) { }

    findCallerIdVerificationCampaigns(): Observable<any> {
      return this.api.get('vna/caller-id-verification/campaigns');
    }

    findAllCampaigns(): Observable<any> {
        return this.api.get('vna/service-campaign');
    }

    findByMatchName(name: string): Observable<any> {
        return this.api.get('vna/service-campaign', {'name_like': name});
    }

    findByPk(pk: number): Observable<any> {
        return this.api.get('vna/service-campaign/' + pk + '?merged=1');
    }

    findPortalCampaigns(pkPortal: number): Observable<any> {
        return this.api.get('vna/service-campaign', {'portal_pk' : pkPortal, 'chkc' : 1});
    }

    findPortalCampaignsConfig(pkPortal: number): Observable<any> {
        return this.api.get('vna/' + pkPortal + '/service-campaign-config');
    }

    findMergedPortalCampaign(pkCampaign: number): Observable<any> {
        return this.api.get('vna/service-campaign/' + pkCampaign, {'merged' : 1});
    }

    findCampaignActions(pkCampaign: number): Observable<any> {
        return this.api.get('vna/service-campaign/' + pkCampaign + '/pending-action');
    }

    createAction(pkCamp: number, data: Object, file: File): Observable<any> {
        return this.api.post('vna/service-campaign/' + pkCamp + '/action', this.createFormData(data, file));
    }

    updateAction(pkAction: number, data: Object, file: File): Observable<any> {
        return this.api.post('vna/service-campaign/action/' + pkAction, this.createFormData(data, file));
    }

    removeAction(pkAction: number): Observable<any> {
        return this.api.remove('vna/service-campaign/action', pkAction);
    }

    actionToServer(pkAction: number): Observable<any> {
        return this.api.get('vna/service-campaign/action/' + pkAction + '/enqueue');
    }

    getActionPreview(pkAction: number): Observable<any> {
        return this.api.get('vna/service-campaign/action/' + pkAction + '/preview-file');
    }

    getExternalCallbacks(criteria: Object): Observable<any> {
        return this.api.get('vna/external-callback', { 'portal_pk' : criteria['portal_pk'], 'service_pk' : criteria['service_pk'], 'camp_pk' : criteria['camp_pk'] });
    }

    removeExternalCallback(pk: number): Observable<any> {
        return this.api.remove('vna/external-callback', pk);
    }

    exportExternalCallback(pkExt: number, pkTargetCamp: number): Observable<any> {
        return this.api.get('vna/external-callback/' + pkExt + '/' + pkTargetCamp + '/export');
    }

    savePortalService(criteria: Object, configPart: string, aliasSrv: string, data: Object): Observable<any> {
        const url = 'vna/service-campaign/' + criteria['camp_pk'] + '/service-config?segment=' + configPart + '&service_pk=' + criteria['service_pk'] + '&portal_pk=' + criteria['portal_pk'] + '&alias_srv=' + aliasSrv;
        return this.api.post(url, data)
    }

    /**
     * todo: Esto no deberia estar aqui
     * @param {Object} data
     * @param {File} file
     * @returns {Object}
     */
    protected createFormData(data: Object, file: File): Object {

        if(_.isUndefined(file)){
            let httpParams = new HttpParams();
            for (let key of Object.keys(data)){
                if(_.isObject(data[key])){
                    let nestedValues: Object = {};
                    for(let objKey of Object.keys(data[key])){
                        nestedValues[objKey] = data[key][objKey];
                    }
                    httpParams = httpParams.set(key, JSON.stringify(nestedValues));
                }
                else{
                    httpParams = httpParams.set(key, data[key]);
                }
            }
            return httpParams;
        }
        else{
            var formData: FormData = new FormData();

            for (let key of Object.keys(data)){
                if(_.isObject(data[key])){
                    let nestedValues: Object = {};
                    for(let objKey of Object.keys(data[key])){
                        nestedValues[objKey] = data[key][objKey];
                    }
                    formData.append(key, JSON.stringify(nestedValues));
                }
                else{
                    formData.append(key, data[key]);
                }
            }

            formData.append('file', file, file.name);
            return formData;
        }

    }

    createCampaign(data:Object): Observable<any>{
        return this.api.post('vna/service-campaign',data);
    }

    updateCampaign(pk: number, data: Object): Observable<any> {
        return this.api.put('vna/service-campaign', pk, data);
    }

    downloadActionReport(pkCamp: number, pkAction: number, regenerate: number): Observable<any> {
        return this.api.get('vna/service-campaign/' + pkCamp + '/action/' + pkAction + '/report', { 'regenerate' : regenerate });
    }

    downloadActionFile(pkAction: number): Observable<ArrayBuffer> {
      const options = this.api.createOptions({});
      return this.api.getHttp().get(this.api.createUrl('vna/service-campaign/action/' + pkAction + '/download'), {
        'headers' : options['headers'],
        'responseType' : 'arraybuffer'
      });
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/services/vna-campaign.service.ts